import PropTypes from 'prop-types'
import StarRatingsShape from './star_ratings'
import type { StarRatings } from './star_ratings'

interface Author {
  contribution_count: number
  name: string
  organization?: string
  thumbnail: string
}

interface ExternalId {
  source: string
  external_id: string
}

export interface ReviewReply {
  id: number
  text: string
  updatedAt?: Date
}

type ReviewStatus =
  | 'archived'
  | 'draft'
  | 'published'
  | 'quarantined'
  | 'submitted'
  | 'unknown_author'
  | 'unpublished'

interface SupplierExternalId {
  external_id: string
  source: string
}

export interface Review {
  author: Author
  auto_published: boolean
  body: string
  can_direct_message: boolean
  can_edit: boolean
  contract?: string
  contract_vehicle?: string
  external_ids: ExternalId[]
  id: number
  net_promoter: number
  overall_rating: number
  price_rating: number
  quality_rating: number
  review_date: string
  review_reply?: ReviewReply
  service_rating: number
  share_with_supplier: boolean
  source: string
  star_ratings: StarRatings
  supplier_external_ids: SupplierExternalId[]
  supplier_id?: number
  supplier_logo_url?: string
  supplier_name?: string
  supplier_slug?: string
  status: ReviewStatus
  timeliness_rating: number
  title: string
  tracking?: string
}

const authorShape = PropTypes.shape({
  contribution_count: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  organization: PropTypes.string,
  thumbnail: PropTypes.string.isRequired
})

const supplierExternalIdsShape = PropTypes.shape({
  external_id: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired
})

export default PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  author: authorShape.isRequired,
  auto_published: PropTypes.bool.isRequired,
  can_direct_message: PropTypes.bool.isRequired,
  can_edit: PropTypes.bool.isRequired,
  contract: PropTypes.string,
  contract_vehicle: PropTypes.string,
  net_promoter: PropTypes.number.isRequired,
  overall_rating: PropTypes.number.isRequired,
  price_rating: PropTypes.number.isRequired,
  quality_rating: PropTypes.number.isRequired,
  review_date: PropTypes.string.isRequired,
  service_rating: PropTypes.number.isRequired,
  share_with_supplier: PropTypes.bool.isRequired,
  source: PropTypes.string.isRequired,
  star_ratings: StarRatingsShape.isRequired,
  supplier_external_ids: PropTypes.arrayOf(supplierExternalIdsShape.isRequired),
  supplier_id: PropTypes.number,
  supplier_name: PropTypes.string,
  supplier_slug: PropTypes.string,
  supplier_logo_url: PropTypes.string,
  timeliness_rating: PropTypes.number.isRequired,
  tracking: PropTypes.string,
  external_ids: PropTypes.array.isRequired
})
